<script lang="ts">
	import faqImage2xl from "@assets/images/fathers-family-club-faq.jpg?webp&imagetools";
	import faqImageXs from "@assets/images/fathers-family-club-faq.jpg?webp&w=640&imagetools";
	import faqImageLg from "@assets/images/fathers-family-club-faq.jpg?webp&w=960&imagetools";
	import Disclosure from "@components/common/Disclosure.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./FathersClubFaqSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const faqs = [
		{ question: translate("faq1Question"), answer: translate("faq1Answer") },
		{ question: translate("faq2Question"), answer: translate("faq2Answer") },
		{ question: translate("faq3Question"), answer: translate("faq3Answer") },
		{ question: translate("faq4Question"), answer: translate("faq4Answer") },
		{ question: translate("faq5Question"), answer: translate("faq5Answer") },
		{ question: translate("faq6Question"), answer: translate("faq6Answer") },
	];
</script>

<section
	class="full-width grid-container py-10 sm:py-15 md:py-20 lg:pt-25 lg:pb-5 xl:pt-30 xl:pb-10 2xl:pt-40 2xl:pb-20 gap-y-10 sm:gap-y-15 md:gap-y-20 lg:gap-y-25 xl:gap-y-30 2xl:gap-y-40"
>
	<div class="container-8 xl:container-start-7 xl:container-end-12">
		<Heading
			level={2}
			text={translate("faqTitle")}
			class="font-antipol font-medium text-8/tighter text-fcrdarkgray text-center xl:text-left mb-18"
		/>
		<div class="md:min-h-100">
			{#each faqs as faq, index (index)}
				<Disclosure title={faq.question} group="fathers-club-faq">
					<Formatted text={faq.answer} />
				</Disclosure>
			{/each}
		</div>
	</div>
	<div class="xl:order-first xl:container-start-1 xl:container-end-6 flex items-start justify-center xl:h-full">
		<Media
			source={{ type: "image/webp", src: faqImageXs }}
			sourcesets={{ ">lg": faqImageLg, ">2xl": faqImage2xl }}
			width={640}
			height={427}
			alt=""
		/>
	</div>
</section>
